import React, { useEffect, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../css/inspection.css';

function Home() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const underlineRef = useRef(null);
    useEffect(() => {
        const timer = setTimeout(() => {
            if (underlineRef.current) {
                underlineRef.current.classList.add('animate');
            }
        }, 50);
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {/* Section 1: Title */}
            <div className="container-fluid about-bg5 d-flex align-items-center justify-content-start mb-5" style={{ padding: 0, top: '-122px', minHeight: '80vh' }}>
                <div className="container-fluid align-items-center justify-content-center about-content">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="d-flex flex-column flex-md-row align-items-start ms-5">
                                <div className="me-md-5">
                                <h1 className="about-title">Inspection (NDT)</h1>
                                    <h2 className="about-subtitle">Non-Destructive Testing Services</h2>
                                    <div className="about-underline" ref={underlineRef}></div>
                                    <p className="about-desc text-white mt-4" style={{ fontSize: '1.2rem', lineHeight: '1.7', maxWidth: '600px' }}>
                                        Petrochoice are skilled and distinguished in the field of engineering inspection of all types, including non-destructive tests (NDT), whether in the field of drilling or the field of petroleum refining.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Services Overview Section */}
            <div className="container py-5">
                <div className="row justify-content-center mb-5">
                    <div className="col-lg-10">
                        <div className="card border-0 shadow-lg intro-card" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                            <div className="card-body p-5" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                                <div className="text-center mb-4">
                                    <div className="bg-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                                        <i className="fas fa-search text-white" style={{ fontSize: '2rem' }}></i>
                                    </div>
                                    <h2 className="fw-bold mb-3" style={{ color: '#0c61c0', fontFamily: 'Poppins, sans-serif' }}>
                                        Our NDT Services
                                    </h2>
                                </div>
                                <p className="text-center mb-0" style={{ fontSize: '1.1rem', lineHeight: '1.7', color: '#495057' }}>
                                    Petrochoice provides a fully trained team that holds accredited certificates, ensures the highest efficiency, and supplies the appropriate equipment for various inspection operations.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* NDT Methods Grid */}
                <div className="row g-4">
                    {[
                        {
                            icon: "fas fa-eye",
                            title: "Visual Inspection Testing",
                            desc: "Comprehensive visual examination of materials and structures to detect surface defects and irregularities.",
                            color: "#0c61c0"
                        },
                        {
                            icon: "fas fa-radiation",
                            title: "Radiographic Testing",
                            desc: "Advanced X-ray and gamma-ray techniques for internal defect detection and weld inspection.",
                            color: "#28a745"
                        },
                        {
                            icon: "fas fa-wave-square",
                            title: "Ultrasonic Testing",
                            desc: "High-frequency sound waves to detect internal flaws and measure material thickness accurately.",
                            color: "#fd7e14"
                        },
                        {
                            icon: "fas fa-magnet",
                            title: "Magnetic Particle Testing",
                            desc: "Detection of surface and near-surface discontinuities in ferromagnetic materials.",
                            color: "#dc3545"
                        },
                        {
                            icon: "fas fa-tint",
                            title: "Dye Penetrant Testing",
                            desc: "Surface-breaking defect detection using liquid penetrant and developer techniques.",
                            color: "#6f42c1"
                        },
                        {
                            icon: "fas fa-project-diagram",
                            title: "Phased Array Testing",
                            desc: "Advanced ultrasonic technique using multiple elements for precise defect characterization.",
                            color: "#20c997"
                        },
                        {
                            icon: "fas fa-chart-line",
                            title: "TOFD (Time of Flight Diffraction)",
                            desc: "Ultrasonic technique for accurate sizing and positioning of defects in welds.",
                            color: "#ffc107"
                        },
                        {
                            icon: "fas fa-atom",
                            title: "PMI (Positive Material Identification)",
                            desc: "Chemical composition analysis to verify material grade and alloy content.",
                            color: "#17a2b8"
                        },
                        {
                            icon: "fas fa-fire",
                            title: "PWHT (Post Weld Heat Treatment)",
                            desc: "Controlled heating and cooling processes to improve weld properties and reduce residual stresses.",
                            color: "#e83e8c"
                        },
                        {
                            icon: "fas fa-hammer",
                            title: "Hardness Test",
                            desc: "Measurement of material hardness to assess mechanical properties and heat treatment effectiveness.",
                            color: "#6c757d"
                        },
                        {
                            icon: "fas fa-microscope",
                            title: "Ferrite Test",
                            desc: "Measurement of ferrite content in stainless steel welds to ensure proper microstructure.",
                            color: "#28a745"
                        },
                        {
                            icon: "fas fa-tools",
                            title: "Welding & Repair Procedures",
                            desc: "Comprehensive welding and repair services performed upon request with certified procedures.",
                            color: "#fd7e14"
                        }
                    ].map((item, index) => (
                        <div key={index} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={index * 100}>
                            <div className="card h-100 border-0 shadow-sm inspection-card" style={{
                                borderRadius: '12px',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}>
                                <div className="card-body p-4">
                                    <div className="d-flex align-items-start mb-3">
                                        <div 
                                            className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0" 
                                            style={{ 
                                                width: '50px', 
                                                height: '50px',
                                                backgroundColor: item.color + '20',
                                                transition: 'all 0.3s ease'
                                            }}
                                        >
                                            <i className={`${item.icon} text-white`} style={{ 
                                                fontSize: '1.2rem',
                                                color: item.color + '!important'
                                            }}></i>
                                        </div>
                                        <div className="flex-grow-1">
                                            <h5 className="fw-bold mb-2" style={{ 
                                                fontSize: '1.1rem', 
                                                color: '#1e293b',
                                                fontFamily: 'Poppins, sans-serif'
                                            }}>
                                                {item.title}
                                            </h5>
                                        </div>
                                    </div>
                                    <p className="mb-0" style={{ 
                                        fontSize: '0.95rem', 
                                        lineHeight: '1.6', 
                                        color: '#64748b',
                                        textAlign: 'justify'
                                    }}>
                                        {item.desc}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Additional Services Section */}
                <div className="row justify-content-center mt-5">
                    <div className="col-lg-10">
                        <div className="card border-0 shadow-lg commitment-card" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                            <div className="card-body p-5 text-center" style={{ background: 'linear-gradient(135deg, #0c61c0 0%, #084b9a 100%)' }}>
                                <div className="bg-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                                    <i className="fas fa-certificate text-primary" style={{ fontSize: '2rem' }}></i>
                                </div>
                                <h3 className="text-white fw-bold mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                                    Certified Excellence
                                </h3>
                                <p className="text-white mb-0" style={{ fontSize: '1.1rem', lineHeight: '1.7', opacity: '0.9' }}>
                                    Our team holds accredited certificates and maintains the highest standards of quality and efficiency in all inspection operations. We also perform welding and repair procedures upon request with certified methodologies.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Home;